import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import tagApi from '../../../../services/tagApi';
import TagBadge from '../../../../views/tags/components/TagBadge';

const TagSelector = ({
  selectedTags = [],
  onChange,
  label = 'Tags',
  productId,
}) => {
  const [tagList, setTagList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getTagList = async () => {
    try {
      setLoading(true);
      const list = await tagApi.getTags({ pageSize: 100 });
      if (list.data.length > 0) {
        setTagList(list.data);
      }
    } catch (error) {
      console.error('Error fetching tags:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTagList();
  }, []);

  const handleTagSelect = async (tagId) => {
    const CLEAR_VALUE = '__CLEAR__';
    if (tagId === CLEAR_VALUE) {
      tagId = undefined;
    }
    if (!tagId) {
      const existingTag = selectedTags[0];
      if (existingTag && existingTag.id && productId) {
        try {
          await tagApi.deleteCustomProductTag(existingTag.id);
        } catch (error) {
          console.error('Error deleting custom product tag:', error);
        }
      }
      onChange([]);
      return;
    }

    const selectedTag = tagList.find((tag) => tag.id === tagId);
    if (!selectedTag) return;

    const existingTag = selectedTags.find(
      (selectedTag) => (selectedTag.tagid || selectedTag.tag?.id) === tagId
    );

    if (existingTag) {
      onChange([existingTag]);
    } else {
      onChange([
        {
          tagid: selectedTag.id,
          tag: selectedTag,
        },
      ]);
    }
  };

  const getSelectedTagIds = () => {
    if (selectedTags.length > 0) {
      return selectedTags[0].tagid || selectedTags[0].tag?.id;
    }
    return undefined;
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-slate-400 mb-2">
        {label}
      </label>

      <Select
        allowClear={false}
        loading={loading}
        size="large"
        style={{ width: '100%' }}
        placeholder="Select a tag"
        value={getSelectedTagIds()}
        onChange={handleTagSelect}
        options={[
          {
            label: 'Clear selection',
            value: '__CLEAR__',
            disabled: !getSelectedTagIds(),
          },
          ...tagList.map((tag) => ({
            label: tag.text,
            value: tag.id,
          })),
        ]}
        optionRender={(option) => {
          const tag = tagList.find((t) => t.id === option.value);
          return tag ? (
            <div className="flex items-center gap-2">
              <TagBadge
                text={tag.text}
                textColor={tag.textColor}
                color={tag.color}
                size="xs"
              />
            </div>
          ) : (
            option.label
          );
        }}
      />
    </div>
  );
};

export default TagSelector;
